











































































































































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import SectionWrappe from "../section/SectionWrappe.vue";
import Button from "@/components/button/Button.vue";
import Tag from "@/components/tag/tag.vue";
import * as types from "@/store/constants/types";
import NumUtils from "@/utils/numUtils";
import GeneralUtilsHelper from "@/utils/generalUtils";
import CountDown from "@/components/countDown/CountDown.vue";
import { sendEvent } from "@/utils/analytics";
import { isIos } from "@/utils/lodash";
import coinsTitle from "./coinsTitle.vue";
import { CDN_BASE_URL } from "@/config/config";
import * as AppLifeCycle from "@/utils/appLifeCycle";
import MoreOption from "@/components/moreoption/moreoption.vue";
import { makeId } from "@/utils/objectId";
@Component({
  components: {
    SectionWrappe,
    CountDown,
    Button,
    Tag,
    coinsTitle,
    MoreOption
  }
})
export default class SkuSection extends Vue {
  @Prop({ default: "follow" })
  private type?: any;
  @Prop({ default: "iap" })
  private filter?: string;
  // @Prop({ default: true })
  // private titleShow?: boolean;
  @Action(types.PAY_BY_ANY) private payByAny: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO) private currentInsUserInfo: any;
  @Getter(types.GETTER_LOCALIZE_PRICE) private localizePrice: any;
  @Getter(types.GETTER_IS_HAPPY_HOUR) private isHappyHour: any;
  @Getter(types.GETTER_DOUBLE_COINS_PERCENTAGE)
  private doubleCoinsPercentage: any;
  @Getter(types.GETTER_SETTING_DATA) private setting: any;

  // private setting?: any = this.$store.state.settingModule.settingData;
  private doubleShow?: boolean = true;
  private halfShow?: boolean = true;

  private countDownTime: number = 0;
  private timeArr: any = [];

  private startCountDownTimer: any = null;
  private initialCountDownTimer: any = null;

  private timestamp: any = "";
  private objectId = "SkuSection-" + makeId();

  private typeData: any = [
    {
      type: "follow",
      settingName: "follow_offers",
      title: "Followers",
      titleContent: "Real Instagram followers",
      titleIcon: require("@/assets/icons-file/sku/icon_followers_2.png"),
      itemIcon: require("@/assets/icons-file/sku/icon_followers.png")
    },
    {
      type: "goldenFollower",
      settingName: "golden_follow_offers",
      title: "Golden Followers",
      titleContent: "",
      titleIcon: require("@/assets/icons-file/sku/icon_golden_followers_2.png"),
      itemIcon: require("@/assets/icons-file/sku/icon_golden_followers.png")
    },
    {
      type: "like",
      title: "Likes",
      settingName: "like_offers",
      titleContent: "Real & fast Instagram likes",
      titleIcon: require("@/assets/icons-file/sku/icon_likes_2.png"),
      itemIcon: require("@/assets/icons-file/sku/icon_likes.png")
    },
    {
      type: "comment",
      title: "Comments",
      settingName: "comment_offers",
      titleContent: "Real Instagram comments",
      titleIcon: require("@/assets/icons-file/sku/icon_comments_2.png"),
      itemIcon: require("@/assets/icons-file/sku/icon_comments.png")
    },
    {
      type: "view",
      title: "Views",
      settingName: "view_offers",
      titleContent: "Real Instagram views",
      titleIcon: require("@/assets/icons-file/sku/icon_views_2.png"),
      itemIcon: require("@/assets/icons-file/sku/icon_views.png")
    },
    {
      type: "coin",
      // title: "Regular Packages",
      settingName: "coin_offers",
      titleContent: "",
      titleIcon: require("@/assets/icons-file/coins/ico_coinstore_regularpackages@3x.png"),
      itemIcon: require("@/assets/icons-file/coins/coins_3.png")
    }
  ];

  get format() {
    return NumUtils.format;
  }

  get typeObj() {
    return this.typeData.find((item: any) => {
      return item.type === this.type;
    });
  }

  get isHalf() {
    return this.isHalfCoins && this.halfShow && this.typeObj.type === "coin";
  }

  get happyHourUI() {
    const multiple = Math.floor(this.doubleCoinsPercentage / 100);
    let image = ""; //require("@/assets/icons-file/double_coins/pic_coinsstore_happyhour.png");
    let background = "linear-gradient(to top, #4b3acd, #4b3acd)";

    if (multiple === 2) {
      image = this.isHappyHour
        ? require("@/assets/icons-file/double_coins/happy/pic_coinstore_happyx2@3x.png")
        : require("@/assets/icons-file/double_coins/pic_coinstore_x2value@3x.png");
      background = this.isHappyHour
        ? "linear-gradient(to top, #4b3acd, #4b3acd)"
        : "linear-gradient(to bottom, #ff6e35, #ff542b)";
    } else if (multiple === 3) {
      image = this.isHappyHour
        ? require("@/assets/icons-file/double_coins/happy/pic_coinstore_happyx3@3x.png")
        : require("@/assets/icons-file/double_coins/pic_coinstore_x3value@3x.png");
      background = this.isHappyHour
        ? "linear-gradient(to top, #3d63e3, #6c5fcf)"
        : "linear-gradient(to top, #5b61c7, #5884e2)";
    } else if (multiple === 4) {
      image = this.isHappyHour
        ? require("@/assets/icons-file/double_coins/happy/pic_coinstore_happyx4@3x.png")
        : require("@/assets/icons-file/double_coins/pic_coinstore_x4value@3x.png");
      background = this.isHappyHour
        ? "linear-gradient(to top, #0071dd, #763dd7)"
        : "linear-gradient(to top, #4b3acd, #582e91)";
    }
    return { image, background, multiple };
  }

  get isDouble() {
    console.log(
      "this.isDoubleCoins",
      this.isDoubleCoins,
      this.doubleShow,
      this.typeObj.type
    );
    return (
      this.isDoubleCoins && this.doubleShow && this.typeObj.type === "coin"
    );
  }

  get isLoginUser() {
    return GeneralUtilsHelper.isLoginUser();
  }

  get isDoubleCoins() {
    return GeneralUtilsHelper.isDoubleCoins();
  }

  get isHalfCoins() {
    return GeneralUtilsHelper.isHalfCoins();
  }

  get skuSectionShow() {
    return this.offerList.length !== 0;
  }

  get localizePriceText() {
    return GeneralUtilsHelper.localizePriceText;
  }

  get singlePrice() {
    const price = this.setting.prices ? this.setting.prices : false;
    if (!price) {
      return false;
    } else {
      const isgold = this.type.indexOf("goldenFollower") > -1 ? true : false;
      if (isgold) {
        return price["golden_follow"];
      } else {
        return price[this.type];
      }
    }
  }

  private localizePriceOriginalText(item: any) {
    if (isIos()) {
      return this.localizePrice(item.iap.original_product_id)
        ? `${
            this.localizePrice(item.iap.original_product_id).localSymbol
          } ${NumUtils.toDecimal2(
            this.localizePrice(item.iap.original_product_id).price
          )}`
        : item.iap.original_price;
    } else {
      return item.iap.original_price;
    }
  }

  private coinIcon(offer: any, index: any) {
    //根据effect先排序
    if (this.offerList.length < 3) {
      //小于三个就不排序了
      return require("@/assets/icons-file/coins/coins_3.png");
    }
    const newOfferList: any = [...this.offerList];
    const sort = (arr: any[]) => {
      for (let j = 0; j < arr.length - 1; j++) {
        //两两比较，如果前一个比后一个大，则交换位置。
        for (let i = 0; i < arr.length - 1 - j; i++) {
          if (arr[i].effect > arr[i + 1].effect) {
            const temp = arr[i];
            arr[i] = arr[i + 1];
            arr[i + 1] = temp;
          }
        }
      }
    };
    sort(newOfferList);
    const splitNum = Math.floor(newOfferList.length / 3);

    if (offer.effect <= newOfferList[splitNum - 1].effect) {
      return require("@/assets/icons-file/coins/coins_1.png");
    } else if (offer.effect <= newOfferList[splitNum * 2 - 1].effect) {
      return require("@/assets/icons-file/coins/coins_2.png");
    } else {
      return require("@/assets/icons-file/coins/coins_3.png");
    }
  }

  get percentage() {
    return (
      this.setting.coin_limit_sale && this.setting.coin_limit_sale.percentage
    );
  }

  private discount(offer: any) {
    return this.isDouble
      ? Math.ceil(100 - ((100 - (offer.discount || 0)) / this.percentage) * 100)
      : offer.discount;
  }

  get showCoinsOffer() {
    // return this.isLoginUser
    //   ? this.currentInsUserInfo.userType === "login"
    //     ? true
    //     : false
    //   : false;
    //改为随便看看都有
    return true;
  }

  get halfCoin() {
    let newArr: any = [];
    if (this.setting == null) {
      return newArr;
    } else {
      newArr = this.setting.half_coin_offers;
      return newArr;
    }
  }

  get offerList() {
    let newArr: any = [];
    if (this.setting == null) {
      return newArr;
    } else {
      newArr = this.setting[this.typeObj.settingName];
      if (!newArr) {
        return [];
      }

      //随便看看模式下,金币不显示：
      newArr = newArr.filter((item: any) => {
        return this.showCoinsOffer
          ? item.way === this.filter && item.effect !== 0
          : item.way === this.filter &&
              item.effect !== 0 &&
              item.way !== "coin";
      });
      return newArr;
    }
  }

  private bestTagShow(item: any) {
    return item.hasOwnProperty("is_best_deal") && item.is_best_deal
      ? true
      : false;
  }

  private clickItem(item: any, index: number) {
    console.log("江傲点击了购买项：", new Date().valueOf());
    this.payByAny({
      offer: item
    })
      .then(() => {})
      .catch((err: any) => {});

    //GA打点：
    if (this.isDoubleCoins && item.kind === "coin") {
      sendEvent("uia_sku_item_click", "double_coins");
      sendEvent("uia_double_coins_click", "coins_store");
    } else if (this.isHalfCoins && item.kind === "coin") {
      sendEvent("uia_sku_item_click", "half_coin");
      sendEvent("uia_half_price_coins_click", "coins_store");
    } else if (item.kind === "coin") {
      sendEvent("uia_sku_item_click", "regular_coin");
    } else {
      sendEvent("uia_sku_item_click", item.kind);
    }
  }

  private startCountDown(time: number) {
    this.countDownTime = Math.floor(time / 1000);
    this.startCountDownTimer = setInterval(() => {
      this.countDownTime -= 1;
      if (this.countDownTime <= 0) {
        console.log("skusection countdown complete");
        this.doubleShow = false;
        this.halfShow = false;
        clearInterval(this.startCountDownTimer);
      }
    }, 1000);
  }

  private initialCountDown() {
    //开始初始化：
    const nowTimeStamp = new Date().valueOf();
    this.clearTimer();
    if (
      this.isDoubleCoins &&
      this.setting.coin_limit_sale.end_time - nowTimeStamp > 0
    ) {
      console.log("double");
      this.doubleShow = true;
      this.startCountDown(this.setting.coin_limit_sale.end_time - nowTimeStamp);
    } else if (this.isHalfCoins) {
      console.log("half");
      this.halfShow = true;
      this.startCountDown(this.setting.coin_half_sale.end_time - nowTimeStamp);
    } else {
      this.doubleShow = false;
      this.halfShow = false;
      this.clearTimer();
    }
  }

  private clearTimer() {
    clearInterval(this.startCountDownTimer);
    clearTimeout(this.initialCountDownTimer);
  }

  private mounted() {
    //TODO 在actived中也需要做
    AppLifeCycle.addListener({
      key: this.objectId,
      fn: async () => {
        console.log("执行AppLifeCycle ,skusection.vue");
        this.initialCountDown();
      }
    });

    this.initialCountDown();

    // coins_store中展示doubleCoins时埋点 uia_double_coins_show
    if (this.skuSectionShow && this.isDouble) {
      sendEvent("uia_double_coins_show", "coins_store");
    }

    if (
      this.isHalfCoins &&
      this.halfShow &&
      this.typeObj.type === "coin" &&
      this.halfCoin.length > 0
    ) {
      sendEvent("uia_half_price_coins_show", "coins_store");
    }

    //展示打点：
    sendEvent("uia_sku_item_show", this.type);
  }

  private beforeDestroy() {
    this.clearTimer();
    AppLifeCycle.removeListener(this.objectId);
  }

  @Watch("countDownTime", { immediate: true })
  private changeTime(time: number, num: number, oldVal: number) {
    const h =
      Math.floor(time / 3600) < 10
        ? "0" + Math.floor(time / 3600)
        : Math.floor(time / 3600);
    const m =
      Math.floor((time / 60) % 60) < 10
        ? "0" + Math.floor((time / 60) % 60)
        : Math.floor((time / 60) % 60);
    const s =
      Math.floor(time % 60) < 10
        ? "0" + Math.floor(time % 60)
        : Math.floor(time % 60);
    this.timeArr = [h, m, s];
  }
}
